import { ArrowUpRight } from "lucide-react";
import { FOUNDER_URL } from "../lib/bopta";
import { Brand } from "./Brand";

export const VBCta = ({ title = "Is the bottleneck the founder?", text = "measures how staff depend on their managers. VentureBaseline's Founder Dependency Assessment measures how the business depends on its founder. Together they map every bottleneck." }) => (
  <div className="rounded-2xl bg-[var(--teal)] p-8 text-white sm:p-10" data-testid="venturebaseline-cta">
    <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#FFB48A]">VentureBaseline ecosystem</p>
    <h3 className="mt-3 text-2xl font-bold sm:text-3xl">{title}</h3>
    <p className="mt-3 max-w-xl text-white/70">{text.startsWith("measures") ? <><Brand /> {text}</> : text}</p>
    <a href={FOUNDER_URL} target="_blank" rel="noreferrer" className="btn mt-6 bg-white text-[var(--ink)]" data-testid="venturebaseline-cta-link">
      Founder Dependency Assessment <ArrowUpRight className="h-4 w-4" />
    </a>
  </div>
);
